<div class="spinner-container" *ngIf="spinnerActive">
  <sa-spinner-infinity [size]="80" [thickness]="100" [speed]="100" color="rgba(185, 141, 120, 1)" secondaryColor="rgba(172, 57, 57, 0.09)"></sa-spinner-infinity>
</div>